import(/* webpackMode: "eager" */ "/vercel/path0/src/app/account/page.tsx");
